import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';

interface IProps {
  color?: string;
}

const MyDivider = styled(Divider)<IProps>(({ theme, color }) => ({
  borderBottomColor: color || '#dddddd',
  borderBottomWidth: 2,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export function SectionDivider({ color, id }: { color?: string, id?: string }) {
  if (id) {
    return (
      <div id={id}>
        <MyDivider color={color} />
      </div>
    );
  }
  return (
    <MyDivider color={color} />
  );
}

export default SectionDivider;
